import {
  API_SUCCESS,
  API_FAIL,
  GET_CHARTS_DATA,
  GET_DASHBOARD_DATA,
  GET_DASHBOARD_DATA_SUCCESS,
  GET_DASHBOARD_DATA_FAIL,
  GET_PROMOTER_PROFILE_DETAILS,
  GET_PROMOTER_PROFILE_DETAILS_SUCCESS,
  GET_PROMOTER_PROFILE_DETAILS_FAIL,
  GET_PROMOTER_DASHBOARD_DATA,
  GET_PROMOTER_DASHBOARD_DATA_SUCCESS,
  GET_PROMOTER_DASHBOARD_DATA_FAIL,
  GET_DASHBOARD_LEAD_CHART_DATA,
  GET_DASHBOARD_LEAD_CHART_DATA_SUCCESS,
  GET_DASHBOARD_LEAD_CHART_DATA_FAIL,
  GET_DASHBOARD_VEHICLE_CHART_DATA,
  GET_DASHBOARD_VEHICLE_CHART_DATA_SUCCESS,
  GET_DASHBOARD_VEHICLE_CHART_DATA_FAIL,
  GET_DASHBOARD_SALE_CHART_DATA,
  GET_DASHBOARD_SALE_CHART_DATA_SUCCESS,
  GET_DASHBOARD_SALE_CHART_DATA_FAIL,

  GET_LEAD_TO_SALE_RATIO,
  GET_LEAD_TO_SALE_RATIO_SUCCESS,
  GET_LEAD_TO_SALE_RATIO_FAIL,
  GET_SALES_REPORT_DATA,
  GET_SALES_REPORT_DATA_SUCCESS,
  GET_SALES_REPORT_DATA_FAIL,
  GET_PURCHASE_REPORT_DATA,
  GET_PURCHASE_REPORT_DATA_SUCCESS,
  GET_PURCHASE_REPORT_DATA_FAIL,
} from "./actionTypes"

export const apiSuccess = (actionType, data) => ({
  type: API_SUCCESS,
  payload: { actionType, data },
})

export const apiFail = (actionType, error) => ({
  type: API_FAIL,
  payload: { actionType, error },
})

// charts data
export const getChartsData = periodType => ({
  type: GET_CHARTS_DATA,
  payload: periodType,
})

//Dashboard Data

export const getDashboardData = isStoreAdmin => ({
  type: GET_DASHBOARD_DATA,
  payload: isStoreAdmin,
})

export const getDashboardDataSuccess = dashboardData => ({
  type: GET_DASHBOARD_DATA_SUCCESS,
  payload: dashboardData,
})

export const getDashboardDataFail = error => ({
  type: GET_DASHBOARD_DATA_FAIL,
  payload: error,
})

// promoter profile data

export const getPromoterProfileDetails = () => ({
  type: GET_PROMOTER_PROFILE_DETAILS,
  payload: "",
})

export const getPromoterProfileDetailsSuccess = promoterProfile => ({
  type: GET_PROMOTER_PROFILE_DETAILS_SUCCESS,
  payload: promoterProfile,
})

export const getPromoterProfileDetailsFail = error => ({
  type: GET_PROMOTER_PROFILE_DETAILS_FAIL,
  payload: error,
})

// promoter dashboard data

export const getPromoterDashboardData = () => ({
  type: GET_PROMOTER_DASHBOARD_DATA,
  payload: "",
})

export const getPromoterDashboardDataSuccess = promoterDashboardData => ({
  type: GET_PROMOTER_DASHBOARD_DATA_SUCCESS,
  payload: promoterDashboardData,
})

export const getPromoterDashboardDataFail = error => ({
  type: GET_PROMOTER_DASHBOARD_DATA_FAIL,
  payload: error,
})

//  -----------/ charts  /----
//lead

export const getDashboardLeadChartData = query => ({
  type: GET_DASHBOARD_LEAD_CHART_DATA,
  payload: query,
})

export const getDashboardLeadChartDataSuccess = leadChartData => ({
  type: GET_DASHBOARD_LEAD_CHART_DATA_SUCCESS,
  payload: leadChartData,
})

export const getDashboardLeadChartDataFail = error => ({
  type: GET_DASHBOARD_LEAD_CHART_DATA_FAIL,
  payload: error,
})

// vehicle

export const getDashboardVehicleChartData = query => ({
  type: GET_DASHBOARD_VEHICLE_CHART_DATA,
  payload: query,
})

export const getDashboardVehicleChartDataSuccess = vehicleChartData => ({
  type: GET_DASHBOARD_VEHICLE_CHART_DATA_SUCCESS,
  payload: vehicleChartData,
})

export const getDashboardVehicleChartDataFail = error => ({
  type: GET_DASHBOARD_VEHICLE_CHART_DATA_FAIL,
  payload: error,
})

//sale

export const getDashboardSaleChartData = query => ({
  type: GET_DASHBOARD_SALE_CHART_DATA,
  payload: query,
})

export const getDashboardSaleChartDataSuccess = saleChartData => ({
  type: GET_DASHBOARD_SALE_CHART_DATA_SUCCESS,
  payload: saleChartData,
})

export const getDashboardSaleChartDataFail = error => ({
  type: GET_DASHBOARD_SALE_CHART_DATA_FAIL,
  payload: error,
})



// Lead to Sale Ratio
export const getLeadToSaleRatio = query => ({
  type: GET_LEAD_TO_SALE_RATIO,
  payload: query,
})

export const getLeadToSaleRatioSuccess = data => ({
  type: GET_LEAD_TO_SALE_RATIO_SUCCESS,
  payload: data,
})

export const getLeadToSaleRatioFail = error => ({
  type: GET_LEAD_TO_SALE_RATIO_FAIL,
  payload: error,
})

// Sales Report
export const getSalesReportData = query => ({
  type: GET_SALES_REPORT_DATA,
  payload: query,
})

export const getSalesReportDataSuccess = data => ({
  type: GET_SALES_REPORT_DATA_SUCCESS,
  payload: data,
})

export const getSalesReportDataFail = error => ({
  type: GET_SALES_REPORT_DATA_FAIL,
  payload: error,
})

// Purchase Report
export const getPurchaseReportData = query => ({
  type: GET_PURCHASE_REPORT_DATA,
  payload: query,
})

export const getPurchaseReportDataSuccess = data => ({
  type: GET_PURCHASE_REPORT_DATA_SUCCESS,
  payload: data,
})

export const getPurchaseReportDataFail = error => ({
  type: GET_PURCHASE_REPORT_DATA_FAIL,
  payload: error,
})
